'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002414 from "./presto.-Dashboard-View$$anon$14.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dHost$002dStats$0024 from "./presto.types$-Dashboard-Host-Stats$.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$13() {
  this.aJp = null;
  this.aJh = null;
  this.aJi = false;
  this.aJq = null;
  this.aJr = false;
  this.aJu = null;
  this.aJn = null;
  this.aJo = false;
  this.aJj = null;
  this.aJk = false;
  this.aJl = null;
  this.aJm = false;
  this.aJs = false;
  this.aJt = false;
  this.aJp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aJu = "DashboardHostStats";
}
export { $c_Lpresto_DashboardView$$anon$13 as $c_Lpresto_DashboardView$$anon$13 };
$p = $c_Lpresto_DashboardView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$13;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$13() {
}
export { $h_Lpresto_DashboardView$$anon$13 as $h_Lpresto_DashboardView$$anon$13 };
$h_Lpresto_DashboardView$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aJp;
});
$p.L = (function() {
  if ((!this.aJi)) {
    this.aJh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aJi = true;
  }
  return this.aJh;
});
$p.O = (function() {
  if ((!this.aJr)) {
    this.aJq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aJr = true;
  }
  return this.aJq;
});
$p.E = (function() {
  return this.aJu;
});
$p.t = (function() {
  if ((!this.aJo)) {
    this.aJn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("host", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("errors", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("rate", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("parcel", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aJo = true;
  }
  return this.aJn;
});
$p.M = (function() {
  if ((!this.aJk)) {
    this.aJj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().v8(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().o5, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().o5, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aJk = true;
  }
  return this.aJj;
});
$p.Q = (function() {
  if ((!this.aJm)) {
    this.aJl = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002414.$c_Lpresto_DashboardView$$anon$14();
    this.aJm = true;
  }
  return this.aJl;
});
$p.w = (function() {
  if ((!this.aJt)) {
    this.aJs = false;
    this.aJt = true;
  }
  return this.aJs;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee52) => ((p) => \u03b4scrutinee52.cGu(p)))($j_presto$002etypes$0024$002dDashboard$002dHost$002dStats$0024.$m_Lpresto_types$DashboardHostStats$())));
});
var $d_Lpresto_DashboardView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$13, "presto.DashboardView$$anon$13", ({
  GF: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$13 as $d_Lpresto_DashboardView$$anon$13 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$13.js.map
